import { Link } from 'react-router-dom';
import { ArrowLeft, Lock } from 'lucide-react';
import { TARIFE, LAUFZEITEN, LAUFZEIT_LABEL, LINIE_LABEL, BETREUTER_EINSTIEG, CHECKUP, CHECKUP_INKLUSIVE, VORAUSZAHLER, GYM_SAUNA, wochenToVierWochen, fmtEuro } from '../lib/tarife';

const LINIEN = ['erwachsene', 'kinder', 'family'];

export default function VerkaufReferenzPage() {
  return (
    <div className="space-y-6 max-w-4xl" data-testid="verkauf-referenz">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-100 text-amber-700 text-[11px] font-bold mb-1">
            <Lock className="w-3.5 h-3.5" /> Nur intern — nicht für den Kundenfluss
          </div>
          <h1 className="text-xl font-bold tracking-tight">Tarifübersicht (Berater-Referenz)</h1>
          <p className="text-xs text-muted-foreground">Alle Preise sind Wochenpreise · Monatsbeitrag = Wochenpreis × 4 (zwölf Zahlungen im Jahr)</p>
        </div>
        <Link to="/verkauf" className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid="back-verkauf">
          <ArrowLeft className="w-4 h-4" /> Zum Verkaufsrechner
        </Link>
      </div>

      {LINIEN.map(linie => (
        <div key={linie} className="bg-white rounded-2xl border border-border/60 overflow-hidden">
          <div className="px-4 py-2.5 bg-muted/40 text-sm font-bold">{LINIE_LABEL[linie]}</div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border/60 text-muted-foreground text-xs">
                  <th className="text-left px-4 py-2 font-medium">Tarif</th>
                  {LAUFZEITEN.map(lz => <th key={lz} className="text-right px-4 py-2 font-medium">{LAUFZEIT_LABEL[lz]}</th>)}
                </tr>
              </thead>
              <tbody>
                {TARIFE.filter(t => t.linie === linie).map(t => (
                  <tr key={t.id} className="border-b border-border/20">
                    <td className="px-4 py-2.5">
                      <div className="font-semibold">{t.name}</div>
                      <div className="text-[11px] text-muted-foreground">{t.einheiten}</div>
                    </td>
                    {LAUFZEITEN.map(lz => (
                      <td key={lz} className="text-right px-4 py-2.5">
                        {t.wochenpreis[lz] == null ? (
                          <div className="text-muted-foreground">—</div>
                        ) : (<>
                          <div className="font-bold">{fmtEuro(t.wochenpreis[lz])}<span className="text-[10px] font-normal text-muted-foreground"> / Wo.</span></div>
                          <div className="text-[10px] text-muted-foreground">= {fmtEuro(wochenToVierWochen(t.wochenpreis[lz]))} / 4 Wo.</div>
                        </>)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      <div className="bg-white rounded-2xl border border-border/60 p-5 text-sm space-y-1.5">
        <h3 className="font-bold mb-1">Einmal-/Zusatzbausteine</h3>
        <div className="flex justify-between"><span className="text-muted-foreground">Betreuter Einstieg · Erwachsene</span><span className="font-medium">{fmtEuro(BETREUTER_EINSTIEG.regulaer)} regulär · {fmtEuro(BETREUTER_EINSTIEG.tag1)} am Beratungstag (Tag 1)</span></div>
        <div className="flex justify-between"><span className="text-muted-foreground">Betreuter Einstieg · Kinder</span><span className="font-medium">{fmtEuro(BETREUTER_EINSTIEG.kinder.regulaer)} regulär · {fmtEuro(BETREUTER_EINSTIEG.kinder.tag1)} am Beratungstag · je Familie max. {BETREUTER_EINSTIEG.maxProFamilie} Einstiege, ab der dritten Person frei</span></div>
        <div className="flex justify-between"><span className="text-muted-foreground">P1 Check-Up Standard</span><span className="font-medium">{CHECKUP.standard.minuten} Min · {fmtEuro(CHECKUP.standard.preis)}</span></div>
        <div className="flex justify-between"><span className="text-muted-foreground">P1 Check-Up Intensiv</span><span className="font-medium">{CHECKUP.intensiv.minuten} Min · {fmtEuro(CHECKUP.intensiv.preis)}</span></div>
        <div className="flex justify-between"><span className="text-muted-foreground">Gym & Sauna Add-on</span><span className="font-medium">{fmtEuro(GYM_SAUNA.wochenpreis)} / Wo. ({fmtEuro(GYM_SAUNA.wochenpreis * 4)} / 4 Wo.) · monatlich kündbar · in Plus enthalten</span></div>
        <div className="flex justify-between"><span className="text-muted-foreground">Vorauszahler-Rabatt</span><span className="font-medium">{Math.round(VORAUSZAHLER.m12 * 100)} % (12 Mon.) · {Math.round(VORAUSZAHLER.m24 * 100)} % (24 Mon.) auf die Gesamtsumme</span></div>
        <div className="text-[11px] text-muted-foreground pt-1">Standard-Check-Ups inklusive: {CHECKUP_INKLUSIVE.m12} bei 12 Monaten, {CHECKUP_INKLUSIVE.m24} bei 24 Monaten Laufzeit (Family: frei auf beide Personen verteilbar; flexibel und 6 Monate: keine). Empfohlene Laufzeit: 24 Monate. Erst-Empfehlung je Linie: der 2×-Tarif (Performance / Performance Kids / Family); 1×-Basic nur als kleinere Alternative.</div>
      </div>
    </div>
  );
}
